<template>
  <div class='content'>
    <div class="title-1">{{ $t('content59') }}</div>
    <div class="title-2">{{ $t('content60') }}</div>
    <!-- <div class="btn-box">
      <div class="btn-blue">预约演示</div>
      <div class="btn-we">参观一下</div>
    </div> -->
    <div class="con-1">
      <img :src="$i18n.locale == 'zh' ? require('@/assets/img_199.png'):require('@/assets/en_img_11.png')" class="con-1-img" alt="">
      <img src="@/assets/img_200.png" class="con-img-200" alt="">
      <img :src="$i18n.locale == 'zh' ? require('@/assets/img_201.png'):require('@/assets/en_img_code1.png')" class="con-img-201" alt="">
    </div>

    <div class="earth-box">
      <img v-if="img5" :src="$i18n.locale == 'zh' ? require('@/assets/img_pay9.png'):require('@/assets/en_img_10.png')" class="bg-10" :class="{
        'pulse-animate': animateBg10,
        'sweet-potato-animation': sweetPotatoBg10,
        'fade-out-animation': showFadeOutBg10
      }" alt="">
      <div class="new-white-box" :class="{
        'show': showNewWhiteBox,
        'slide-and-fade': slideAndFadeWhiteBox
      }">
        <img src="@/assets/img_52.png" class="bg-img-6" alt="">
        <img src="@/assets/img_101.png" class="bg-img-7" alt="">
        <div class="white_text" :class="$i18n.locale + '_white_text'">{{ $t('content20') }}</div>
        <div class="white_number">40.00 USD</div>
        <img :src="$i18n.locale == 'zh' ? require('@/assets/img_46.png'):require('@/assets/en_img_r.png')" class="bg-img-8" alt="">
        <img src="@/assets/img_09.png" class="bg-img-9" alt="">
      </div>
      <img  :src="$i18n.locale == 'zh' ? require('@/assets/img_9.png'):require('@/assets/en_img_7.png')" class="bg-9" v-if="sweetPotatoBg11" :class="{ 'pulse-animate1': animateBg9 }"
        alt="">

      <div class="text-12" :class="$i18n.locale+'_text-12'" v-if="showText">
        <span class="typing-text" :class="{ 'pulse-text': pulseBg12 }">
          {{ displayText12 }}
        </span>
      </div>
      <div class='text-13' :class="$i18n.locale+'_text-13'" v-if="showText">
        <span class="typing-text" :class="{ 'pulse-text': pulseBg13 }">
          {{ displayText13 }}
        </span>
      </div>
      <div :class="{ 'show-slide': showBgImg4 }" v-if="img4">

        <img src="@/assets/img_09.png" class="bg-img-4" alt="">
      </div>
    </div>

    <div :class="$i18n.locale + '_img-url'">
      <!-- <img src="@/assets/bg2@2x.png" style="width:100%;height: 876px;" alt=""> -->
      <div class="title-3">{{ $t('content61') }}</div>
      <div class="title-4">
        {{ $t('content62') }}
      </div>
      <div class="flex-box">
        <div flex>
          <div class="flex-left" :class="{ active: color == 0 }" @click="cliText(0)">

            <div class="img-box1" v-if="color == 0">
              <img src="@/assets/xuanz_icon@2x.png" class="com-img" alt="">
            </div>
            <div class="img-box" v-else>
              <img src="@/assets/xuanz_icon@2x.png" class="com-img" alt="">
            </div>
            <div class="font-1">{{ $t('content63') }}</div>
          </div>
          <div class="flex-left" :class="{ active: color == 1 }" @click="cliText(1)">
            <div class="img-box1" v-if="color == 1">
              <img src="@/assets/tianxie_icon@2x.png" class="com-img" alt="">
            </div>
            <div class="img-box" v-else>
              <img src="@/assets/tianxie_icon@2x.png" class="com-img" alt="">
            </div>
            <div class="font-1">{{ $t('content64') }}</div>
          </div>
          <div class="flex-left1" :class="{ active: color == 2 }" @click="cliText(2)">
            <div class="img-box1" v-if="color == 2">
              <img src="@/assets/fasong_icon@2x.png" class="com-img" alt="">
            </div>
            <div class="img-box" v-else>
              <img src="@/assets/fasong_icon@2x.png" class="com-img" alt="">
            </div>
            <div class="font-1">{{ $t('content65') }}</div>
          </div>
          <div class="flex-left1" :class="{ active: color == 3 }" @click="cliText(3)">
            <div class="img-box1" v-if="color == 3">
              <img src="@/assets/tongbu_icon@2x.png" class="com-img" alt="">
            </div>
            <div class="img-box" v-else>
              <img src="@/assets/tongbu_icon@2x.png" class="com-img" alt="">
            </div>
            <div class="font-1">{{ $t('content66') }}</div>
          </div>
        </div>
        <div class="con-2">
          <img :src="$i18n.locale == 'zh' ? require('@/assets/xuanz_img@2x.png'):require('@/assets/en_xuanz_img@2x.png')" v-if="color == 0" class="con-2-img" alt="" @click="amplifier(0)">
          <img :src="$i18n.locale == 'zh' ? require('@/assets/tianxie_img@2x.png'):require('@/assets/en_tianxie_img@2x.png')" v-if="color == 1" class="con-2-img" alt="" @click="amplifier(1)">
          <img :src="$i18n.locale == 'zh' ? require('@/assets/fasong_img@2x.png'):require('@/assets/en_fasong_img2@2x.png')" v-if="color == 2" class="con-2-img" alt="" @click="amplifier(2)">
          <img :src="$i18n.locale == 'zh' ? require('@/assets/tongbu_img@2x.png'):require('@/assets/en_tongbu_img2.png')" v-if="color == 3" class="con-2-img" alt="" @click="amplifier(3)">
        </div>
        <div class="con-0">
          <img :src="$i18n.locale == 'zh' ? require('@/assets/xuanz_img2@2x.png'):require('@/assets/en_xuanz_img.png')" v-if="color == 0 && isEnlargement" alt="" @click="narrow()">
          <img :src="$i18n.locale == 'zh' ? require('@/assets/tianxie_img2@2x.png'):require('@/assets/en_tianxie_img.png')" v-if="color == 1 && isEnlargement" alt="" @click="narrow()">
          <img :src="$i18n.locale == 'zh' ? require('@/assets/fasong_img2.png'):require('@/assets/en_fasong_img2.png')" v-if="color == 2 && isEnlargement" alt="" @click="narrow()">
          <img :src="$i18n.locale == 'zh' ? require('@/assets/tongbu_img2@2x.png'):require('@/assets/en_tongbu_img.png')" v-if="color == 3 && isEnlargement" alt="" @click="narrow()">
        </div>
      </div>

    </div>

    <div>
      <div class="title-5">{{ $t('content67') }}</div>
      <div class="title-6">{{ $t('content68') }}</div>
      <div class="middle-box">
        <div class="left-box">
          <div class="title-img">
            <img src="@/assets/linghuofukuan_icon@2x.png" class="con-img-1" alt="">
          </div>
          <div class="title-7">{{ $t('content69') }}</div>
          <div class="title-8">{{ $t('content70') }}</div>
          <img src="@/assets/linghuofukuan_img@2x.png" class="con-img-2" alt="">
        </div>
        <div class="right-box">
          <div class="title-img">
            <img src="@/assets/jianhua_icon@2x.png" class="con-img-1" alt="">
          </div>
          <div class="title-7">{{ $t('content71') }}</div>
          <div class="title-8">{{ $t('content72') }}</div>
          <img src="@/assets/jianhua_img@2x.png" class="con-img-2" alt="">
        </div>
      </div>
    </div>
    <div class="right-text-box">
      <div class="left-boxs">
        <div class="con-3">
          <img src="@/assets/chongzhiliuchneg_img@2x.png" class="con-3-img" alt="">
        </div>
      </div>
      <div class="right-boxs">
        <div class="con-4">
          <div class="con-5">{{ $t('content73') }}</div>
          <div class="con-6">{{ $t('content74') }}</div>
        </div>
      </div>


    </div>
    <div class="con-7">
      <div class="con-8">
        <div class="con-9">{{ $t('content75') }}</div>
        <div class="con-10">{{ $t('content76') }}
        </div>
        <div class="con-11">
          <img src="@/assets/Slice 25@2x.png" class="con-12" alt="">
          <div class="con-13">{{ $t('content77') }}</div>
        </div>
        <div class="con-14">
          <img src="@/assets/Slice 25@2x.png" class="con-12" alt="">
          <div class="con-13">{{ $t('content78') }}</div>
        </div>
        <div class="con-14">
          <img src="@/assets/Slice 25@2x.png" class="con-12" alt="">
          <div class="con-13">{{ $t('content79') }}</div>
        </div>
      </div>
      <div class="con-15">
        <img :src="$i18n.locale == 'zh' ? require('@/assets/xuanze_img@2x.png'):require('@/assets/en_Frame.png')" class="con-15-img" alt="">
      </div>
    </div>

    <div class="con-16">
      <div class="con-17">
        <div class="con-18" :class="$i18n.locale + '_con-18'">
          <div class="con-19" :class="$i18n.locale + '_con-19'">
            <img src="@/assets/Slice 26@2x.png" class="con-19-img" alt="">
          </div>
          <div class="con-20">{{ $t('content82') }}</div>
        </div>
        <div class="con-21" :class="$i18n.locale + '_con-18'">
          <div class="con-19" :class="$i18n.locale + '_con-19'">
            <img src="@/assets/Slice 28@2x.png" class="con-19-img" alt="">
          </div>
          <div class="con-22">{{ $t('content83') }}</div>

        </div>
      </div>
      <div class="con-23" :class="$i18n.locale + '_con-18'">
        <div  :class="$i18n.locale + '_con-24'">
          <img src="@/assets/Slice 27@2x.png" class="con-24-img" alt="">
        </div>
        <div class="con-25">{{ $t('content84') }} </div>
      </div>
      <div class="con-26" :class="$i18n.locale + '_con-19'">
        <div class="con-27">{{ $t('content80') }}</div>
        <div class="con-28">{{ $t('content81') }}</div>
      </div>
    </div>

    <div class="con-29">
      <div class="con-30">
        <div class="con-31">{{ $t('content85') }}</div>
        <div class="con-32">
          {{ $t('content86') }}
          </div>
      </div>
      <div class="con-33">
        <img :src="$i18n.locale == 'zh' ? require('@/assets/zhichi_img@2x.png'):require('@/assets/en_zhichi.png')" class="con-33-img" alt="">
      </div>
    </div>
  </div>
</template>

<script>
//import

export default {
  name: 'payPage',
  components: {

  },
  data() {
    return {
      color: 0,
      colorMiddle: 0,
      displayNumber: '273927.00',
      startNumber: 273927.00,
      targetNumber: 78301.00,
      animationActive: false,
      showIconBox: false,
      displayText12: '',
      displayText13: '',
      showBgImg4: false,
      showText: false,
      animateBg9: false,
      animateBg10: false,
      img4: false,
      pulseBg12: false,
      pulseBg13: false,
      sweetPotatoBg10: false,
      sweetPotatoBg11: false,
      showFadeOutBg10: false,
      showNewWhiteBox: false,
      img5: true,
      slideAndFadeWhiteBox: false,
      isEnlargement: false
    };
  },
  computed: {

  },
  watch: {},
  methods: {
    handleGlobalClick(event) {
      if(event.target?.className==='con-2-img') return
      if (this.isEnlargement) {
        this.isEnlargement = false
      }
    },
    amplifier(inedx) {
      this.isEnlargement = true
      this.color = inedx
    },
    narrow() {
      this.isEnlargement = false
    },
    cliText(e) {
      this.color = e
    },
    startNumberAnimation() {
      if (this.animationActive) return

      this.animationActive = true
      let currentNumber = this.startNumber
      const step = (this.startNumber - this.targetNumber) / 25 // 25 steps for smoother transition

      const animateNumber = () => {
        // Generate a random number closer to the target
        currentNumber -= Math.abs(step) + Math.random() * 500

        // Ensure we don't go below the target number
        if (currentNumber <= this.targetNumber) {
          currentNumber = this.targetNumber
        }

        // Update the display
        this.displayNumber = currentNumber.toFixed(2)

        // Continue animation if not reached target
        if (currentNumber > this.targetNumber) {
          requestAnimationFrame(animateNumber)
        } else {
          // Reset for next cycle after a delay
          setTimeout(() => {
            this.animationActive = false
            this.startNumberAnimation()
          }, 2000)
        }
      }

      // Start the animation
      requestAnimationFrame(animateNumber)
    },
    triggerIconBoxAnimation() {
      // 在图片动画结束后显示图标
      setTimeout(() => {
        this.showIconBox = true
      }, 3000) // 根据动画总时长调整
    },
    typeText(text, callback) {
      let index = 0;
      const typeWriter = () => {
        if (index < text.length) {
          this.displayText12 = text.slice(0, index + 1)
          index++
          setTimeout(typeWriter, 100) // 每个字符间隔100ms
        } else {
          callback && callback()
        }
      }
      typeWriter()
    },
    typeText2(text) {
      let index = 0
      const typeWriter = () => {
        if (index < text.length) {
          this.displayText13 = text.slice(0, index + 1)
          index++
          setTimeout(typeWriter, 100) // 每个字符间隔100ms
        }
      }
      typeWriter()
    },
    startTextAnimation() {
      this.sweetPotatoBg10 = true
      setTimeout(() => {
        this.sweetPotatoBg11 = true
        this.$nextTick(() => {
          this.animateBg9 = true;  // 触发动画
        });
      }, 100)

      setTimeout(() => {
        this.showText = true
        this.typeText('40.00', () => {
          // 第一个文本打完后，开始第二个
          setTimeout(() => {
            this.typeText2('53.844')
            this.img4 = true
            if (this.img4) {
              setTimeout(() => {
                this.showBgImg4 = true
                this.animateBg9 = true
                this.animateBg10 = true
                this.img5 = false

                // 整个动画序列结束后重新开始
                setTimeout(() => {
                  this.resetAnimationState()
                  this.startTextAnimation()
                  this.typeText12 = ''
                  this.typeText13 = ''
                  this.sweetPotatoBg11 = false

                }, 3000) // 根据整个动画周期调整时间
              }, 2000)
              setTimeout(() => {
                this.showText = false
              }, 1100)
              setTimeout(() => {
                this.showFadeOutBg10 = true

                setTimeout(() => {
                  this.showNewWhiteBox = true
                }, 800)

                setTimeout(() => {
                  this.slideAndFadeWhiteBox = true
                }, 3000)
              }, 100)

              setTimeout(() => {
                this.triggerTextPulse()
                this.sweetPotatoBg11 = false
                this.img4 = false
              }, 1100)
            }
          }, 500)
        })
      }, 2000)
    },

    resetAnimationState() {
      // 重置所有状态，准备下一个循环
      this.showText = false
      this.img4 = false
      this.img5 = true
      this.showBgImg4 = false
      this.animateBg9 = false
      this.animateBg10 = false
      this.showFadeOutBg10 = false
      this.showNewWhiteBox = false
      this.slideAndFadeWhiteBox = false
      this.sweetPotatoBg10 = false
      this.sweetPotatoBg11 = true
      this.pulseBg12 = false
      this.pulseBg13 = false
    },
    triggerTextPulse() {
      // 确保动画触发
      this.pulseBg12 = true
      this.pulseBg13 = true

      // 额外的强制重绘
      this.$nextTick(() => {
        const text12 = document.querySelector('.text-12 .typing-text')
        const text13 = document.querySelector('.text-13 .typing-text')

        if (text12) {
          text12.classList.add('pulse-text')
          void text12.offsetWidth // 触发重绘
        }

        if (text13) {
          text13.classList.add('pulse-text')
          void text13.offsetWidth // 触发重绘
        }
      })
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.startNumberAnimation()
    this.triggerIconBoxAnimation()
    this.startTextAnimation()
    document.addEventListener('click', this.handleGlobalClick)
  },
}
</script>
<style scoped>
.content {
  padding-top: 87px;
  margin: 0 auto
}

.con-1 {
  margin: 0 auto;
  text-align: center;
}

.con-1-img {
  width: 1400px;
  height: 800px;
}

.con-img-200 {
  width: 350px;
  height: 240px;
  position: absolute;
  top: 755px;
  right: 425px;
  z-index: 1;
}

.bg-img-4 {
  width: 65px;
  height: 65px;
  position: absolute;
  top: -95px;
  left: 430px;
  z-index: 15;
  opacity: 1;
  filter: blur(0px);
  transition: all 0.1s cubic-bezier(0.4, 0, 0.2, 1);
}

.bg-img-4.show-slide {
  opacity: 1;
  filter: blur(0);
}

.con-img-201 {
  width: 420px;
  height: 380px;
  position: absolute;
  top: 640px;
  right: 190px;
}

.text-12,
.text-13 {
  position: absolute;
  left: 350px;
  font-size: 16px;
  z-index: 9999;
  color: #333;
  transition: transform 0.3s ease, color 0.3s ease;
  /* transform-origin: center; */
  display: inline-block;
  /* 确保变换正常 */
}

.text-12.pulse-text,
.text-13.pulse-text {
  animation: text-pulse 1s ease-in-out forwards;
}

.typing-text.pulse-text {
  animation: text-pulse 1s ease-in-out forwards !important;
  display: inline-block;
  transform-origin: center;
}

.typing-text {
  position: relative;
  display: inline-block;
}

.typing-text::after {
  content: '|';
  display: inline-block;
  margin-left: 2px;
  animation: blink 0.7s infinite;
}

@keyframes text-pulse {
  0% {
    transform: scale(1);
    color: #333;
  }

  0% {
    transform: scale(0.8);
    color: #333;
  }

  100% {
    transform: scale(1);
    color: #333;
  }
}

.zh_text-12 {
  top: -270px;
}

.en_text-12 {
  top: -256px;
}

.zh_text-13 {
  top: -120px;
}
.en_text-13 {
  top: -160px;
}

.con-2 {
  margin-left: 108px;
}

.con-0 {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  right: auto;
  z-index: 10000;
}

.con-2-img {
  width: 763px;
  height: 400px;
}

.con-3 {
  width: 682px;
  height: 620px;
  margin-left: 284px;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 61px 54px 61px 76px;
}

.con-3-img {
  width: 552px;
  height: 498px;
}

.con-img-1 {
  width: 54px;
  height: 54px;
}

.con-img-2 {
  width: 480px;
  height: 380px;
}

.con-4 {
  width: 576px;
  padding-top: 241px;
}

.con-5 {
  font-size: 36px;
  color: #333333;
  margin-bottom: 14px;
  font-weight: 600;

}

.con-6 {
  font-size: 22px;
  color: #666666;
  line-height: 32px;
}

.con-7 {
  height: 875px;
  display: flex;
}

.con-8 {
  width: 473px;
  height: 875px;
  margin-left: 361px;
  margin-top: 260px;
}

.con-9 {
  font-size: 36px;
  color: #333333;
  margin-bottom: 34px;
  font-weight: 600;

}

.con-10 {
  font-size: 22px;
  color: #666666;
  margin-bottom: 32px;
  line-height: 32px;
}

.con-11 {
  display: flex;
  align-items: center;
}

.con-12 {
  width: 18px;
  height: 18px;
}

.con-13 {
  font-size: 20px;
  color: #333333;
  margin-left: 12px;
}

.con-14 {
  display: flex;
  align-items: center;
  margin-top: 11px;
}

.con-15 {
  /* width: 850px;
  height: 875px; */
  margin-top: 15px;
}

.con-15-img {
  width: 100%;
  height: 100%;
}

.con-16 {
  padding: 90px 0;
  background-color: #F8F9FF;
  display: flex;
}

.con-17 {
  margin-left: 360px;
  /* padding-top: 90px; */
}

.bg-10.pulse-animate {
  animation:
    click-pulse 1s ease-in-out forwards;
}

.bg-9.pulse-animate1 {
  animation:
    slide-left-to-right 2s cubic-bezier(0.4, 0, 0.2, 1) forwards;

}

@keyframes slide-left-to-right {
  0% {
    transform: translateY(-100%);
    /* 从屏幕左侧完全外部开始 */
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    /* 保持在目标位置 */
    opacity: 1;
  }
}

.bg-10 {
  position: absolute;
  top: -380px;
  left: 250px;
  ;
  width: 400px;
  height: 398px;
  z-index: 10;
  margin-top: -25px;
  transition: transform 0.3s ease;
  transform-origin: center;
}

.new-white-box {
  position: absolute;
  top: -400px;
  left: 250px;
  width: 380px;
  height: 340px;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 10;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.8s ease-out;
}

@keyframes slide-up {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slide-left-to-right-stop {

  /* 0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  } */
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }

  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}

.new-white-box {
  /* 现有样式保持不变 */
  overflow: hidden;
}

.bg-img-6 {
  width: 60px;
  height: 60px;
  position: absolute;
  top: 60px;
  left: 160px;
}

.bg-img-7 {
  width: 40px;
  height: 35px;
  position: absolute;
  top: 70px;
  left: 170px;
}

.bg-img-6,
.bg-img-7,
.white_text,
.white_number,
.bg-img-8 {
  opacity: 0;
}

.bg-img-8 {
  width: 180px;
  height: 40px;
  position: absolute;
  top: 230px;
  left: 100px;
}

.new-white-box.show .bg-img-6 {
  animation: slide-up 0.6s ease-out forwards;
  animation-delay: 0.2s;
}

.new-white-box.show .bg-img-7 {
  animation: slide-left-to-right 0.8s ease-out forwards;
  animation-delay: 0.6s;
}

.white_text {
  font-size: 16px;
  color: #333333;
  position: absolute;
  top: 130px;
}

.zh_white_text {
  left: 155px;
}
.en_white_text {
  left: 120px;
}

.white_number {
  font-size: 19px;
  position: absolute;
  top: 160px;
  left: 140px;
}

.new-white-box.show .white_text {
  animation: slide-up 0.6s ease-out forwards;
  animation-delay: 0.8s;
}

.new-white-box.show .white_number {
  animation: slide-up 0.6s ease-out forwards;
  animation-delay: 1s;
}

.new-white-box.show .bg-img-8 {
  animation: slide-up 0.6s ease-out forwards;
  animation-delay: 1.2s;
}

@keyframes slide-left {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50px);
  }
}

@keyframes box-fade-out {
  0% {
    opacity: 1;
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(0.8);
  }
}

.bg-img-9 {
  width: 65px;
  height: 65px;
  position: absolute;
  top: 220px;
  left: 220px;
  z-index: 15;
  transition: transform 1s ease-in-out;
}

.new-white-box.slide-and-fade .bg-img-9 {
  animation: slide-left 1s ease-in-out forwards;
}

.new-white-box.slide-and-fade {
  animation:
    box-fade-out 0.8s ease-in-out 0.8s forwards;
}

.new-white-box.show {
  opacity: 1;
  transform: scale(1);
}

.bg-9 {
  width: 165px;
  height: 36px;
  position: absolute;
  top: -80px;
  left: 350px;
  z-index: 11;
}

.con-18 {
  width: 271px;
  border-radius: 24px;
  background-color: #fff;
  margin-bottom: 40px;
  text-align: center;
}
.zh_con-18{
  height: 205px;
}
.en_con-18{
  height: 320px;
  padding-top:20px
}

.con-19 {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  box-shadow: 0px 8px 24px 0px #EBEFFA;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.en_con-19{
  margin-bottom: 20px;
}
.con-19-img {
  width: 32px;
  height: 32px;
}

.con-20 {
  font-size: 22px;
  color: #333333;
  width: 189px;
  margin: 0 auto;
}

.con-21 {
  width: 271px;
  border-radius: 24px;
  background-color: #fff;
  text-align: center;
}

.con-22 {
  font-size: 22px;
  color: #333333;
  width: 210px;
  margin: 0 auto;
  line-height: 32px;
}

.con-23 {
  width: 271px;
  border-radius: 24px;
  background-color: #fff;
  margin-left: 40px;
  margin-top: 110px;
  text-align: center;
}

.zh_con-24 {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  box-shadow: 0px 8px 24px 0px #EBEFFA;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 45px;
}

.en_con-24 {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  box-shadow: 0px 8px 24px 0px #EBEFFA;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 20px;
}

.con-24-img {
  width: 32px;
  height: 32px;
}

.con-25 {
  font-size: 22px;
  color: #333333;
  width: 189px;
  margin: 0 auto;
  line-height: 32px;
}

.con-26 {
  width: 527px;
  margin-left: 92px;
  margin-top: 188px
}

.con-27 {
  margin-bottom: 16px;
  font-size: 36px;
  color: #333333;
  font-weight: 600;

}

.con-28 {
  font-size: 23px;
  color: #666666;
  line-height: 32px;
}

.con-29 {
  display: flex;
}

.con-30 {
  width: 576px;
  margin-top: 285px;
  margin-bottom: 273px;
  margin-left: 361px;
}

.con-31 {
  font-size: 36px;
  color: #333333;
  margin-bottom: 18px;
  font-weight: 600;

}

.con-32 {
  font-size: 22px;
  color: #666666;
  line-height: 32px;
}

.con-33 {
  margin-left: 14px;
  margin-top: 140px;
}

.con-33-img {
  width: 609px;
  height: 552px;
}

.title-1 {
  margin-top: 87px;
  font-size: 36px;
  color: #333;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 18px;

}

.title-2 {
  width: 921px;
  font-size: 22px;
  color: #666666;
  text-align: center;
  margin: 0 auto;
  line-height: 32px;
}

.btn-box {
  margin-top: 58px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.btn-blue {
  width: 132px;
  height: 44px;
  font-size: 18px;
  background-color: #4873FF;
  color: #fff;
  border-radius: 5px;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
  margin-right: 12px;
}


.btn-we {
  width: 132px;
  height: 44px;
  font-size: 18px;
  background-color: #fff;
  color: #4873FF;
  cursor: pointer;
  border-radius: 5px;
  line-height: 44px;
  text-align: center;
  border: 1px solid #4873FF;
  margin-left: 12px;

}

.zh_img-url {
  background: url('@/assets/bg2@2x.png');
  background-size: 100% 100%;
  width: 100%;
  height: 876px;
  padding-top: 76px;
}
.en_img-url {
  background: url('@/assets/bg2@2x.png');
  background-size: 100% 100%;
  width: 100%;
  height: 1100px;
  padding-top: 76px;
}

.title-3 {
  font-size: 36px;
  color: #fff;
  text-align: center;
  margin-bottom: 27px;
}

.earth-box {
  position: relative;
}

.title-4 {
  width: 1200px;
  font-size: 22px;
  color: #fff;
  text-align: center;
  margin: 0 auto;
  line-height: 32px;
}

.com-img {
  width: 26px;
  height: 26px;
}

@keyframes sweet-potato-drop {
  0% {
    transform: translateY(-100%) rotate(-15deg);
    opacity: 0;
  }

  70% {
    transform: translateY(10%) rotate(5deg);
    opacity: 0.7;
  }

  100% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
  }
}

@keyframes click-pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0.4);
  }

  50% {
    transform: scale(0.9);
    box-shadow: 0 0 0 10px rgba(0, 123, 255, 0);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 123, 255, 0);
  }
}


@keyframes fade-out {
  0% {
    opacity: 1;
    transform: scale(1);
  }

  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}

.bg-10.fade-out-animation {
  animation:
    fade-out 0.8s ease-out forwards;
}

.bg-10.sweet-potato-animation {
  animation:
    slide-left-to-right-stop 2s cubic-bezier(0.25, 0.1, 0.25, 1) forwards;
}

.flex-box {
  width: 1165px;
  height: 400px;
  margin: 0 auto;
  display: flex;
  margin-top: 104px;
}

.flex-left {
  display: flex;
  align-items: center;
  padding: 30px 23px;
  cursor: pointer;

}

.flex-left1 {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 22px 23px;
}

.img-box {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background-color: #121b4d;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 19px;
}

.img-box1 {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background-color: #4873FF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 19px;
}

.font-1 {
  font-size: 20px;
  color: #fff;
  width: 220px;
}

.active {
  /* background-color: #4873FF; */
  border: 1px solid #4873FF;
  border-radius: 16px;
  background-color: #0a0f41;
}

.title-5 {
  margin-top: 100px;
  font-size: 36px;
  color: #333333;
  text-align: center;
  font-weight: 600;
}

.title-6 {
  width: 1187px;
  font-size: 22px;
  color: #666666;
  text-align: center;
  margin: 0 auto;
  margin-top: 16px;
  margin-bottom: 73px;
  line-height: 32px;
}

.middle-box {
  width: 1200px;
  height: 642px;
  background-color: #fff;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 163px;
}

.left-box {
  width: 574px;
  height: 100%;
  background: linear-gradient(to top, #EAEFFF, #FFFFFF);
  border-radius: 24px;
  padding: 47px;
  margin-right: 54px;
}

.right-box {
  width: 574px;
  height: 100%;
  background: linear-gradient(to top, #EAEFFF, #FFFFFF);
  border-radius: 24px;
  padding: 47px;

}

.title-7 {
  font-size: 24px;
  color: #333333;
  margin-top: 23px;
  font-weight: 600;
}

.title-8 {
  font-size: 20px;
  color: #666666;
  margin-top: 23px;
  margin-bottom: 16px;
  line-height: 32px;
}

.right-text-box {
  height: 642px;
  background-color: #F8F9FF;
  display: flex;

}

.left-boxs {
  width: 50%;
  height: 100%;
}

.right-boxs {
  width: 50%;
  height: 100%;
}

@keyframes slideRight {

  0%,
  100% {
    transform: translateY(100%);
    opacity: 0;
  }

  20%,
  80% {
    transform: translateY(0);
    opacity: 1;
  }
}


.con-img-201 {
  animation: slideRight 6s infinite;
}

/* Animation for con-img-200: Top to Bottom Reveal */
@keyframes topToBottomRevealAndFade {

  0%,
  10% {
    clip-path: polygon(0 0, 100% 0, 100% 0%, 0 0%);
    opacity: 0;
  }

  40%,
  80% {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    opacity: 1;
  }

  90%,
  100% {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    opacity: 0;
  }
}

.con-img-200 {
  animation: topToBottomRevealAndFade 6s infinite;
  position: absolute;
  top: 745px;
  right: 240px;
  z-index: 1;
  width: 340px;
  height: 240px;
  opacity: 1;
  transform-origin: top center;
}
</style>